<div class="row g-0">
  <div class="col-8">
    <h5 class="m-0 p-0 text-dark">
      Drug {{ position + 1 }}: {{ name }}

      @if (showWarningIndicator) {
        <fa-icon [icon]="['fas', 'exclamation-triangle']" size="1x" class="warning" />
      }
    </h5>
  </div>
  <div class="col-3"><ng-content /></div>
  <div class="col-1 text-end">
    <a href="#toggleCollapsed" class="toggle" (click)="onToggleCollapseClick($event)">
      @if (!collapsed) {
        <mat-icon>remove</mat-icon>
      }
      @if (collapsed) {
        <mat-icon>add</mat-icon>
      }
    </a>
  </div>
</div>
